import { render, staticRenderFns } from "./redPackageAddAgent.vue?vue&type=template&id=83f5aa4c&scoped=true&"
import script from "./redPackageAddAgent.vue?vue&type=script&lang=js&"
export * from "./redPackageAddAgent.vue?vue&type=script&lang=js&"
import style0 from "./redPackageAddAgent.vue?vue&type=style&index=0&id=83f5aa4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f5aa4c",
  null
  
)

component.options.__file = "redPackageAddAgent.vue"
export default component.exports